import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { CommonFunctionsService} from '../../../../_services/index';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CommonService }  from '../../service/index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MalihuScrollbarService } from 'ngx-malihu-scrollbar';

@Component({
    selector: 'expediusa-shared-element-testimonial',
    templateUrl: './testimonial.component.html',
	styleUrls : ['./testimonial.component.css'], 
	providers: [CommonFunctionsService]
	
})

  
export class TestimonialComponent implements OnInit, OnDestroy {

	/**This is used to prevent memory leaks **/
	private ngUnsubscribe: Subject<void> = new Subject<void>();
	/**This is used to prevent memory leaks **/

	env	=	environment;
    testimonialData : any = [];
    image_url : any = '';
	customOptions: OwlOptions = {
		loop: true,
		mouseDrag: false,
		touchDrag: false,
		pullDrag: false,
		dots: false,
		navSpeed: 700,
		margin:10,
		navText: ['', ''],
		responsive:{
			0:{
				items:1
			},
			567:{
				items:1
			},
			768:{
				items:2
			}, 
			992:{
				items:3
			},
			1200:{
				items:3
			}
		},
		nav:true,
	}

	// Declare Constructor
	constructor(
		public commonFunctionsService: CommonFunctionsService, 
		private commonService : CommonService,
		private renderer:Renderer2,
		private mScrollbarService: MalihuScrollbarService
	){}

	// Declare initialization
	ngOnInit(): void {
		let scroll = 0;
		this.renderer.listen('window', 'scroll', (event:any) => {
			const verticalOffset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
			if(verticalOffset>1 && !scroll){
				scroll = 1;
				/**This funcion used to get testimonial after scroll*/
				this.getTestimonials();	
				/**This funcion used to get testimonial after scroll*/
				event.preventDefault();
			}
		});
	}
	
	/**This funcion used to get testimonial after scroll*/
	public getTestimonials(){
		this.commonService.getTestimonial().pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
			if (response.status === this.env.SUCCESS_STATUS) {
				this.testimonialData	= response.result;
				this.image_url			= response.image_path;				
				this.commonFunctionsService.isBrowser.subscribe((isBrowser) => {
					if (isBrowser){
						let that = this;
						setTimeout(()=>{
							that.mScrollbarService.initScrollbar('', { axis: 'y', theme: 'dark-thick' });
						},500)
					}
				});
			}
		});
	}
	/**This funcion used to get testimonial after scroll*/

	
	/**This function are used for destroy the data**/
	ngOnDestroy(): void {
		this.ngUnsubscribe.next();
	}
	/**This function are used for destroy the data**/

}
